import { useCreate } from '@refinedev/core';

type GenerateMeetingAgendaInput = {
  templateId: string;
};

export const useGenerateCalendarEventMeetingAgenda = (eventId: string) => {
  const { mutateAsync, error, isLoading, isError, isSuccess } =
    useCreate<GenerateMeetingAgendaInput>({
      resource: `calendar-events/${eventId}/meeting-agenda`,
    });

  const generateMeetingAgenda = async (input: GenerateMeetingAgendaInput) => {
    await mutateAsync({
      values: input,
    });
  };

  return {
    generateMeetingAgenda,
    isLoading,
    error,
    isError,
    isSuccess,
  };
};
